import { NoHistoryContainer, NoHistoryText } from '../../AssetHistory.styles';

const NoAssetHistory = () => {
  return (
    <NoHistoryContainer>
      <NoHistoryText>
        There are no history changes to this asset, yet.
      </NoHistoryText>
    </NoHistoryContainer>
  );
};

export { NoAssetHistory };
